import { c as _c } from "react/compiler-runtime";
import React, { FC, SVGProps } from 'react';
export const FollowingIcon: FC<SVGProps<SVGSVGElement>> = props => {
  const $ = _c(13);
  let t0;
  let t1;
  let t10;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path d="M5.75491 7.3418L1.3361 9.32461C0.767554 9.58037 0.400391 10.1473 0.400391 10.7708C0.400391 11.3934 0.767554 11.9613 1.3361 12.2171L4.62079 13.691L4.64782 13.7039L12.1918 10.317L5.75491 7.3418Z" />;
    t1 = <path d="M15.2355 11.7246L7.73633 15.0904L11.6858 16.8639L19.0205 13.4737L15.2355 11.7246Z" />;
    t2 = <path d="M22.0396 14.8672L14.749 18.2366L21.352 21.2006C21.5587 21.2932 21.7798 21.3397 22.0016 21.3397C22.2228 21.3397 22.4436 21.2932 22.6496 21.2006L29.2915 18.2188L22.0396 14.8672Z" />;
    t3 = <path d="M18.9444 7.28231L15.2513 8.94048L8.81445 5.96527L12.4165 4.34863L18.9444 7.28231Z" />;
    t4 = <path d="M25.7743 10.3515L22.039 12.0779L18.2969 10.3492L22.0331 8.6709H22.0338L25.7743 10.3515Z" />;
    t5 = <path d="M28.8347 11.7266L25.0566 13.4724L32.3524 16.8441L36.291 15.0762L28.8347 11.7266Z" />;
    t6 = <path d="M28.5316 2.97971L22.0357 5.89658L15.5078 2.96257L21.3524 0.339365C21.7651 0.153806 22.2374 0.153806 22.65 0.339365L28.5316 2.97971Z" />;
    t7 = <path d="M35.2233 5.98481L28.8174 8.94552L25.1221 7.28505L31.6206 4.36719L35.2233 5.98481Z" />;
    t8 = <path d="M43.603 10.7697C43.603 11.3922 43.2362 11.9601 42.6683 12.2149L39.3826 13.6898H39.382L31.8818 10.3191L38.2884 7.3584L42.6673 9.32341C43.2362 9.57917 43.603 10.1461 43.603 10.7697V10.7697Z" />;
    t9 = <path d="M42.6644 15.1639L42.2075 14.9589L22.6849 23.722C22.4793 23.8146 22.2581 23.8611 22.0366 23.8611C21.8155 23.8611 21.594 23.8146 21.3877 23.722L1.82949 14.9424L1.3361 15.1639C0.768213 15.4196 0.400391 15.9865 0.400391 16.6101C0.400391 17.2327 0.767554 17.8006 1.3361 18.0554L21.3521 27.0406C21.5581 27.1332 21.7792 27.1797 22.0001 27.1797C22.2212 27.1797 22.443 27.1332 22.649 27.0406L42.665 18.0554C43.2329 17.8006 43.6001 17.2327 43.6001 16.6101C43.6001 15.9865 43.2332 15.4196 42.6644 15.1639V15.1639Z" />;
    t10 = <path d="M42.6644 21.0912L42.1558 20.8628L22.6846 29.6032C22.479 29.6958 22.2578 29.7423 22.0363 29.7423C21.8152 29.7423 21.5937 29.6958 21.3874 29.6032L1.88058 20.8467L1.33577 21.0916C0.767554 21.3467 0.400391 21.9142 0.400391 22.5371C0.400391 23.1604 0.767554 23.7276 1.3361 23.9831L21.3511 32.9677C21.5574 33.0606 21.7789 33.1068 22.0004 33.1068C22.2215 33.1068 22.4427 33.0603 22.6487 32.968L42.6647 23.9827C43.2329 23.7276 43.6001 23.1601 43.6001 22.5371C43.6001 21.9142 43.2329 21.3467 42.6644 21.0912V21.0912Z" />;
    $[0] = t0;
    $[1] = t1;
    $[2] = t10;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
    $[6] = t5;
    $[7] = t6;
    $[8] = t7;
    $[9] = t8;
    $[10] = t9;
  } else {
    t0 = $[0];
    t1 = $[1];
    t10 = $[2];
    t2 = $[3];
    t3 = $[4];
    t4 = $[5];
    t5 = $[6];
    t6 = $[7];
    t7 = $[8];
    t8 = $[9];
    t9 = $[10];
  }
  let t11;
  if ($[11] !== props) {
    t11 = <svg {...props} viewBox="0 0 44 34" fill="current" xmlns="http://www.w3.org/2000/svg">{t0}{t1}{t2}{t3}{t4}{t5}{t6}{t7}{t8}{t9}{t10}</svg>;
    $[11] = props;
    $[12] = t11;
  } else {
    t11 = $[12];
  }
  return t11;
};